<template>
<div>
    <div class="container winner_list">
    <div class="d-flex box">
        <SelectButton id="btn1" button_name="可兌換" :button_active="clickwinbtn1" @click.native="change" ></SelectButton>
        <SelectButton id="btn2" button_name="已過期" :button_active="clickwinbtn2" @click.native="pired" ></SelectButton>
    </div>
    </div>
        <list id="list" :list='winner' :router_name='router_name'></list>
    <div  class="container  winner_list">
        <div v-show="winner.length == 0 && nodata == false" style="margin:40px auto;font-size:21px;text-align: center;">
            <img src="../../assets/loading.gif">
        </div>
        <div v-show="nodata && !clickwinbtn2" style="margin:40px auto;font-size:21px;text-align: center;">目前無可兌換名單</div>
        
        <moreButton button_text="返回首頁" button_href="/"></moreButton>
    </div>
        
    
</div>

</template>
<script>
import list from '@/components/list/list'
import select_button from '@/components/list/select_button'
import MoreButton from '@/components/index/MoreButton'
export default {
     components: {
        'list': list,
        'SelectButton': select_button,
        'moreButton': MoreButton,
    },
    data(){
        return {
            router_name:'winner_page',
            winner: [],
            exchange:[],
            expired:[],
            clickwinbtn1:true,
            clickwinbtn2:false,
            nodata:false,
        }
    },
     computed: {
    API() {
      return process.env.NODE_ENV === 'production' ? 'https://www.top-link.com.tw/' : 'http://localhost/'
    }
  },
    created(){
    var vm = this;
     var news_api = vm.API + 'api/tlweb/news?kind=3&online=1'
     var news2_api = vm.API + 'api/tlweb/news?kind=3&online=0'
    
    vm.axios.get(news_api)
      .then(function (response) {
        
        vm.exchange = response.data.data.data.reverse()  
        vm.winner = vm.exchange
        for(var deleteHtmlTag=0;deleteHtmlTag<vm.exchange.length;deleteHtmlTag++){
            vm.exchange[deleteHtmlTag].content = vm.exchange[deleteHtmlTag].content.replace(/<[^>]+>|&[^>]+;/g,"").trim();
        }
         if (vm.winner.length == 0) {
                vm.nodata = true
                } else {
                vm.nodata = false
                }
                console.log(vm.nodata)
      })
      .catch(function (error) {
        console.log(error);
      });
      
    vm.axios.get(news2_api)
      .then(function (response) {
        vm.expired = response.data.data.data.reverse()    
        for(var deleteHtmlTag=0;deleteHtmlTag<vm.expired.length;deleteHtmlTag++){
            vm.expired[deleteHtmlTag].content = vm.expired[deleteHtmlTag].content.replace(/<[^>]+>|&[^>]+;/g,"").trim();
        }    
        
      })
      .catch(function (error) {
        console.log(error);
      });
      
  },
   methods: {
       
       change(){
        //    console.log(1);
           this.winner=this.exchange;
           this.clickwinbtn2=false;
           this.clickwinbtn1=true;
            
       },
       pired(){
        //    console.log(2);
           this.winner=this.expired;
           this.clickwinbtn1=false;
           this.clickwinbtn2=true;
           
       },
   }
}
</script>
<style>
.winner_list .box{
    justify-content: center;
    margin-bottom: 15px;
}
.winner_list .select_button{
    margin: 1px;
}
.winner_list  #list{
    font-size: 31px;
    padding-top: 30px;
    text-align: center;
}
/* .winner_list #btn1 .btm_box{
    border-right: 1px solid #00a0e9;
}
.winner_list #btn2 .btm_box{
    border-left: 1px solid #00a0e9;
} */

</style>




